module.exports = __webpack_public_path__ + "img/Equip.841dcff8.jpg";